import { WorkerType } from "./WorkerType";

export const INITIAL_VALUES: WorkerType = {
	workerTypeId: 0,
	workerTypeName: "",
};
